<template>
  <div id="app">
    <div>
      <component :is="currentView"></component>
    </div>
    <div v-if="message!=''" class="cdisp">
      {{ message }}
    </div>
  </div>
</template>

<script>
import TimerTest from './components/Timer.vue'
export default {
  name: 'App',
  data(){
    return{
      currentView: 'TimerTest',
      message: '',
    }
  },
  components: {
    TimerTest
  },
  methods: {
    view1: function() {
      this.message = ""
      this.currentView = "TimerTest"
    },
     touchmove: function(event) {
        // ２本指での操作の場合
        if (event.touches.length >= 2) {
          // デフォルトの動作をさせない
          event.preventDefault();
        }
     }
  }
}
</script>

<style>
.cdisp{
    display: flex;
    align-items: center;
    justify-content: center;
}
#app button{
  background: rgba(255, 0, 0, 0.8);
  color: rgba(255, 255, 255, 1);
  width: 120px;
  height: 120px;
  line-height: 120px;
  border-radius: 50%;
  font-weight: bold;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.29);
}
#app button:active {
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
  border-bottom: none;
}
</style>
